import { useState, type MouseEvent } from "react";
import { Button } from "@components/ui/button";
import { useForm } from "react-hook-form";
import { Form } from "@/components/ui/form";
import FormFieldInput from "../../FormField/FormFieldInput";
import { zodResolver } from "@hookform/resolvers/zod";
import { LoginFormValuesType, loginFormSchema } from "../schemas";
import ToggleVisibilityButton from "../../ToggleVisibilityButton/ToggleVisibilityButton";

type LoginFormPropsType = { onSubmit: (values: LoginFormValuesType) => void };

function LoginForm({ onSubmit }: LoginFormPropsType) {
  const [isPassVisible, setIsPassVisible] = useState(false);
  const form = useForm<LoginFormValuesType>({
    resolver: zodResolver(loginFormSchema),
    defaultValues: {
      email: "",
      password: "",
    },
  });
  const toggleVisibility = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setIsPassVisible((x) => !x);
  };

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="w-full space-y-4 align-center justify-center">
        <FormFieldInput form={form} placeholder="E-mail" label="E-mail" name="email" />
        <FormFieldInput
          form={form}
          placeholder="Hasło"
          inputType={isPassVisible ? "text" : "password"}
          label="Hasło"
          sufixElement={<ToggleVisibilityButton onClick={toggleVisibility} isVisible={isPassVisible} />}
          name="password"
        />
        <Button size="lg" type="submit">
          Zaloguj się
        </Button>
      </form>
    </Form>
  );
}

export default LoginForm;
